import type { IFormilySchema } from '../types';

/**
 * Change {%...%} to {{...}} into formily reactions
 * Skip child schemas
 */
const xReactionParser = (schema: IFormilySchema): IFormilySchema => {
  const convertExpression = (expr: string): string => {
    return expr.replace(/\{%([\s\S]+?)%\}/g, '{{$1}}');
  };

  const processNode = (node: any): any => {
    if (!node || typeof node !== 'object') {
      return node;
    }

    const processed = { ...node };

    // Skip processing x-reactions if this is a Form component
    const isFormComponent = processed['x-component'] === 'Form';

    // Process x-reactions if present and not a Form component
    if (!isFormComponent && processed['x-reactions']?.fulfill?.state) {
      const state = processed['x-reactions'].fulfill.state;
      const newState: Record<string, any> = {};

      for (const [key, value] of Object.entries(state)) {
        if (typeof value === 'string') {
          newState[key] = convertExpression(value);
        } else {
          newState[key] = value;
        }
      }

      processed['x-reactions'] = {
        ...processed['x-reactions'],
        fulfill: {
          ...processed['x-reactions'].fulfill,
          state: newState,
        },
      };
    }

    // Recursively process properties (including Form's children)
    if (processed.properties) {
      const newProperties: Record<string, any> = {};

      for (const [key, value] of Object.entries(processed.properties)) {
        newProperties[key] = processNode(value);
      }

      processed.properties = newProperties;
    }

    return processed;
  };

  return processNode(schema);
};

export default xReactionParser;
